<div class="data-list">
    <ng-container *ngIf="rows.length > 0">
        <div class="data-header">
            <ng-content select="cui-data-list-header"></ng-content>
        </div>
        <ng-content select="cui-data-list-item"></ng-content>
    </ng-container>
    <p class="no-data" *ngIf="rows.length == 0">No data found</p>
</div>
